class FlickityCustom {

  constructor() {
    this.heroSlider();
    this.sliderColumn();
    this.quotes();
  }

  quotes() {
    (function ($) {
      var $quotes = $('.quotes-carousel');

      $quotes.flickity({
        groupCells: 'auto',
        prevNextButtons: true,
        contain: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        adaptiveHeight: true
      });
    }(jQuery));
  }

  sliderColumn() {
    (function ($) {
      var $slidercolumn = $('.slider-column');

      $slidercolumn.flickity({
        groupCells: 'auto',
        prevNextButtons: true,
        contain: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true
      });
    }(jQuery));
  }

  heroSlider() {
    (function ($) {
      $('.hero .scroll-down').on('click', function () {
        let after_hero = $(this).parent().next()

        $('html, body').unbind().animate({
          scrollTop: Number($(after_hero).offset().top) - Number($('header#site-header').height())
        }, 500);
      })

      $(window).resize(function () {
        resizeHeroCell();
      });

      var $carousel = $('.hero-slider');

      $carousel.on('ready.flickity', function () {
        resizeHeroCell();
      });

      $carousel.flickity({
        contain: true,
        prevNextButtons: false,
        wrapAround: true
      });

      function resizeHeroCell() {
        let height

        if ($(window).width() >= 992) {
          height = $('.hero-slider .carousel-cell .container').height() > 600 ? $('.hero-slider .carousel-cell .container').height() : 600
        } else {
          height = $('.hero-slider .carousel-cell .container').height() + $('.hero-slider .carousel-cell img').height() + 60;
        }

        $('.hero-slider .carousel-cell, .hero-slider .flickity-viewport').height(height);
      }
    }(jQuery));
  }
}

export default FlickityCustom;
